import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  authorizedGet,
  authorizedPost,
} from "../../../Config/networkWithToken";
import configuration from "../../../Config/configuration";
import MessageBar, {
  config,
  DOBASEURL,
  errorNotify,
  getValueFromLocalStorage,
  localStorageKey,
  successNotify,
} from "../../../utils/helper";
import Spinner from "../../../Components/Spinner/Spinner";
import Strings from "../../../utils/Strings";
import { MdHistory } from "react-icons/md";
import { FaUserCheck } from "react-icons/fa6";
import { FaUserTimes } from "react-icons/fa";
import Images from "../../../utils/images";
import { ImCancelCircle } from "react-icons/im";
import { IoIosSearch } from "react-icons/io";
import AdvanceSearch from "../../../Components/AdvanceSearch/AdvanceSearch";
import RejectModel from "../../../Components/RejectModel/RejectModel";
import { FaEdit } from "react-icons/fa";
import { PiArrowsCounterClockwiseBold } from "react-icons/pi";

const SuggestionCards = ({
  request,
  activeTab,
  index,
  adminId,
  setUserRequestData,
  setUserAcceptedRequest,
  setAdminRejectedRequest,
  setMutuallyAcceptedRequest,
  setUserRejectedRequest,
  setRequests,
}) => {
  const [loadingAcceptRequestId, setLoadingAcceptRequestId] = useState(null);
  const [loadingDenyRequestId, setLoadingDenyRequestId] = useState(null);
  const [isCommentSectionOpen, setIsCommentSectionOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);
  const [requestedId, setRequestedId] = useState(null);
  const [showRejectRevokeConfirmation, setShowRejectRevokeConfirmation] =
    useState(false);
  const [revoking, setRevoking] = useState(false);
  const [userRejectCommentUpdate, setUserRejectCommentUpdate] = useState(false);
  const [matchUserRejectCommentUpdate, setMatchUserRejectCommentUpdate] =
    useState(false);
  const [AdminRejectCommentUpdate, setAdminRejectCommentUpdate] =
    useState(false);
  const role = getValueFromLocalStorage(localStorageKey.USERDATA, "role");
  const canManage = role === "admin" || role === "superAdmin";

  //Admin Request Approval
  const handleApproval = async (decision, requestId) => {
    try {
      if (decision === "approve") {
        setLoadingAcceptRequestId(requestId);
      } else {
        setLoadingDenyRequestId(requestId);
      }

      const data = {
        adminId: adminId,
        matchId: requestId,
        decision: decision === "approve" ? Strings.APPROVE : Strings.REJECT,
        comments: comment,
        isUserCommentUpdate: userRejectCommentUpdate,
        isMatchUserCommentUpdate: matchUserRejectCommentUpdate,
        isAdminCommentUpdate: AdminRejectCommentUpdate,
      };

      const res = await authorizedPost(
        configuration.apis.adminSuggestionReject,
        data,
        config,
      );
      const response = res?.data?.data;

      if (res?.data?.status) {
        successNotify(res?.data?.message);
        setRequests(response || []);
        setUserRequestData(response?.pending || []);
        setUserAcceptedRequest(response?.accepted || []);
        setUserRejectedRequest(response?.rejected || []);
        setMutuallyAcceptedRequest(response?.mutuallyAccepted || []);
        setAdminRejectedRequest(response?.adminRejected || []);
      } else {
        errorNotify(res?.data?.message);
      }
    } catch (error) {
      errorNotify(Strings.ERROR);
      console.log(error);
    } finally {
      setLoadingAcceptRequestId(null);
      setLoadingDenyRequestId(null);
      setUserRejectCommentUpdate(false);
      setMatchUserRejectCommentUpdate(false);
      setAdminRejectCommentUpdate(false);
    }
  };
  const handleNoteChange = (event) => {
    setError(false);
    setComment(event.target.value);
  };

  const closeModal = () => {
    setComment("");
    setError(false);
    setIsCommentSectionOpen(false);
    setUserRejectCommentUpdate(false);
    setMatchUserRejectCommentUpdate(false);
    setAdminRejectCommentUpdate(false);
  };

  const handleAction = (requestedId, decision) => {
    setRequestedId(requestedId);
    if (decision === "approve") {
      handleApproval(decision, requestedId);
      setRevoking(true);
    } else {
      setIsCommentSectionOpen(true);
    }
    setRevoking(true);
    setShowRejectRevokeConfirmation(false);
  };

  const handleSaveComment = () => {
    if (comment.length > 15) {
      handleApproval("reject", requestedId);
      setIsCommentSectionOpen(false);
      setError(false);
      setComment("");
    } else {
      setError(true);
    }
  };
  const getTimeAgoLabel = (sentAt) => {
    const sentDate = new Date(sentAt);
    const now = new Date();

    // Zero out time for accurate day comparison
    const sentDay = new Date(
      sentDate.getFullYear(),
      sentDate.getMonth(),
      sentDate.getDate(),
    );
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const diffInDays = Math.floor((today - sentDay) / (1000 * 60 * 60 * 24));

    if (diffInDays === 0) return "Today";
    if (diffInDays === 1) return "Yesterday";
    if (diffInDays <= 3) return "3 days ago";
    if (diffInDays <= 7) return "1 week ago";
    if (diffInDays <= 14) return "2 weeks ago";
    if (diffInDays <= 30) return "1 month ago";
    if (diffInDays <= 60) return "2 months ago";
    if (diffInDays <= 90) return "3 months ago";
    if (diffInDays <= 180) return "6 months ago";

    return "Over 6 months ago";
  };

  const getDateBadgeColor = (sentAt) => {
    const sentDate = new Date(sentAt);
    const now = new Date();

    const sentDay = new Date(
      sentDate.getFullYear(),
      sentDate.getMonth(),
      sentDate.getDate(),
    );
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const diffInDays = Math.floor((today - sentDay) / (1000 * 60 * 60 * 24));

    if (diffInDays === 0) return "bg-lime-500";
    if (diffInDays === 1) return "bg-fuchsia-500";
    if (diffInDays <= 3) return "bg-blue-500";
    if (diffInDays <= 7) return "bg-yellow-500";
    if (diffInDays <= 14) return "bg-pink-700";
    if (diffInDays <= 30) return "bg-cyan-500";
    if (diffInDays <= 60) return "bg-teal-500";
    if (diffInDays <= 90) return "bg-red-500";
    if (diffInDays <= 180) return "bg-purple-600";

    return "bg-gray-500";
  };

  const handleRejectedReasonEdit = (comment, id) => {
    setComment(comment);
    setRequestedId(id);
    setIsCommentSectionOpen(true);
  };

  const activeStatus = (userData) => {
    if (
      userData?.hasOwnProperty("isActive") &&
      userData?.isActive &&
      userData?.profileCompleted
    ) {
      return "green-400";
    } else if (
      !userData?.hasOwnProperty("isActive") &&
      userData?.profileCompleted
    ) {
      return "green-400";
    } else if (userData?.profileCompletionPercentage > 0) {
      return "yellow-400";
    }
  };
  return (
    <div
      key={index}
      className="font-jost relative flex w-full flex-col items-center gap-2 rounded-xl bg-white p-2 shadow-md md:w-[30%] md:justify-around"
    >
      <div className="flex w-full flex-col items-center gap-2 p-2 md:justify-around xl:flex-row">
        <div className="flex flex-row justify-around">
          {/* Requested User's Profile */}
          <div className="flex flex-col items-center text-center">
            <Link
              to={`/adminsuggestion-history/viewProfile/${request?.matchUser?.id}`}
            >
              <img
                src={
                  request?.matchUser?.profileImage?.length > 0
                    ? DOBASEURL + request?.matchUser?.profileImage[0]
                    : request?.matchUser?.gender === "male"
                      ? Images.MEN
                      : Images.WOMEN
                }
                className="h-20 w-20 cursor-pointer rounded-full border-4 border-yellow-200"
                alt="Requested User"
                onContextMenu={(e) => e.preventDefault()}
                onDragStart={(e) => e.preventDefault()}
              />
            </Link>
            <div className="flex flex-row items-center gap-1">
              <div
                className={`h-[10px] w-[10px] rounded-full bg-${activeStatus(request?.matchUser)}`}
              ></div>
              <span className="scrollbar-hide relative w-[80px] overflow-x-auto whitespace-nowrap text-gray-700">
                {request?.matchUser?.name}
              </span>
            </div>
          </div>
          <div className="flex">
            <PiArrowsCounterClockwiseBold
              className="aria-hidden:true mt-5"
              style={{ fontSize: "40px", color: "#ffbb33" }}
            />
          </div>
          {/* User Profile */}
          <div className="flex flex-col items-center text-center">
            <Link
              to={`/adminsuggestion-history/viewProfile/${request?.user?.id}`}
            >
              <img
                src={
                  request?.user?.profileImage?.length > 0
                    ? DOBASEURL + request?.user?.profileImage[0]
                    : request?.user?.gender === "male"
                      ? Images.MEN
                      : Images.WOMEN
                }
                className="h-20 w-20 cursor-pointer rounded-full border-4 border-yellow-200"
                alt="User"
                onContextMenu={(e) => e.preventDefault()}
                onDragStart={(e) => e.preventDefault()}
              />
            </Link>
            <div className="flex flex-row items-center gap-1">
              <span className="scrollbar-hide relative w-[80px] overflow-x-auto whitespace-nowrap text-gray-700">
                {request?.user?.name}
              </span>
              <div
                className={`h-[10px] w-[10px] rounded-full bg-${activeStatus(request?.user)}`}
              ></div>
            </div>
          </div>
        </div>
        {/* Accept and Deny Buttons */}
        {activeTab === 0 && canManage && (
          <div className="flex w-full flex-row items-center justify-center gap-3 lg:w-[20%] xl:flex-col">
            <button
              className={`right-4 top-4 rounded-full bg-red-500 px-2 py-2 text-xs text-white ${loadingDenyRequestId === request.id ? "cursor-not-allowed opacity-50" : ""}`}
              onClick={() => handleAction(request?.id, "reject")}
              disabled={loadingDenyRequestId === request?.id}
            >
              {loadingDenyRequestId === request?.id ? (
                <Spinner />
              ) : (
                <FaUserTimes />
              )}
            </button>
          </div>
        )}
        {activeTab === 4 && canManage && (
          <button
            className={`absolute right-2 top-2 rounded-full bg-blue-500 p-2 text-xs text-white shadow-md transition duration-300 hover:bg-blue-200 ${
              loadingDenyRequestId === request.id
                ? "cursor-not-allowed opacity-50"
                : ""
            }`}
            onClick={() => {
              setRequestedId(request?.id);
              setShowRejectRevokeConfirmation(true);
            }}
          >
            {loadingDenyRequestId === request?.id ? (
              <Spinner />
            ) : (
              <FaUserCheck />
            )}
          </button>
        )}
        {activeTab === 3 && canManage && (
          <button
            className={`absolute right-2 top-2 rounded-full bg-red-500 p-2 text-xs text-white shadow-md transition duration-300 hover:bg-red-200 ${loadingDenyRequestId === request.id ? "cursor-not-allowed opacity-50" : ""}`}
            onClick={() => handleAction(request?.id, "reject")}
            disabled={loadingDenyRequestId === request?.id}
          >
            {loadingDenyRequestId === request?.id ? (
              <Spinner />
            ) : (
              <FaUserTimes />
            )}
          </button>
        )}
        {activeTab === 1 && canManage && (
          <button
            className={`absolute right-2 top-2 rounded-full bg-red-500 p-2 text-xs text-white shadow-md transition duration-300 hover:bg-red-200 ${loadingDenyRequestId === request.id ? "cursor-not-allowed opacity-50" : ""}`}
            onClick={() => handleAction(request?.id, "reject")}
            disabled={loadingDenyRequestId === request?.id}
          >
            {loadingDenyRequestId === request?.id ? (
              <Spinner />
            ) : (
              <FaUserTimes />
            )}
          </button>
        )}
      </div>
      <div className="flex w-fit items-center gap-2 rounded-lg border border-gray-200 bg-white p-2 text-xs text-gray-800 shadow-sm">
        <span className="inline-flex items-center gap-1 font-semibold">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 text-blue-500"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M6 2a1 1 0 00-1 1v1H5a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V6a2 2 0 00-2-2h-.003V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zM5 8h10v8H5V8z"
              clipRule="evenodd"
            />
          </svg>
          Suggestion Date:
        </span>
        <span className="font-normal text-black">
          {request?.sentAt
            ? new Date(request?.sentAt).toLocaleDateString("en-GB")
            : "N/A"}
        </span>
        {request?.sentAt && (
          <span
            className={`ml-2 flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium text-white shadow-sm ${getDateBadgeColor(request?.sentAt)}`}
          >
            <MdHistory className="text-[12px]" />
            {getTimeAgoLabel(request?.sentAt)}
          </span>
        )}
      </div>

      <div className="w-full px-4 text-left">
        <>
          {/* User Status */}
          <p className="text-bg-black text-left text-xs font-semibold">
            {`${(
              request?.user?.name ||
              request?.user?.name ||
              "User"
            ).substring(0, 10)}${
              (request?.user?.name || request?.user?.name || "").length > 10
                ? "..."
                : ""
            }'s Status:`}

            <span
              className={`ml-1 font-normal capitalize ${
                request?.user?.userdecision === "accepted"
                  ? "text-green-500"
                  : request?.user?.userdecision === "rejected"
                    ? "text-red-500"
                    : "text-yellow-500"
              }`}
            >
              {request?.user?.userdecision || "pending"}
            </span>
          </p>

          {/* Match User Status */}
          <p className="text-bg-black text-left text-xs font-semibold">
            {`${(
              request?.matchUser?.name ||
              request?.matchUser?.name ||
              "Match User"
            ).substring(0, 10)}${
              (request?.matchUser?.name || request?.matchUser?.name || "")
                .length > 10
                ? "..."
                : ""
            }'s Status:`}

            <span
              className={`ml-1 font-normal capitalize ${
                request?.matchUser?.matchedUserdecision === "accepted"
                  ? "text-green-500"
                  : request?.matchUser?.matchedUserdecision === "rejected"
                    ? "text-red-500"
                    : "text-yellow-500"
              }`}
            >
              {request?.matchUser?.matchedUserdecision || "pending"}
            </span>
          </p>

          <p className="text-bg-black text-left text-xs font-semibold">
            {"Admin Name:"}
            <span className="font-normal">{request?.adminName}</span>
          </p>
          {request?.adminDecision === "reject" && (
            <p className="text-bg-black text-left text-xs font-semibold">
              {"Declined Admin Name:"}
              <span className="font-normal">{request?.rejectedAdmin}</span>
            </p>
          )}
          <p className="text-bg-black text-xs font-semibold">
            {request?.adminDecision === "reject"
              ? "Admin Declined Date:"
              : "Admin Suggested Date:"}
            {""}{" "}
            <span className="font-normal">
              {request?.adminDecision === "reject"
                ? request?.adminRejectedAt
                  ? new Date(request?.adminRejectedAt).toLocaleDateString(
                      "en-GB",
                    )
                  : "N/A"
                : request?.sentAt
                  ? new Date(request?.sentAt).toLocaleDateString("en-GB")
                  : "N/A"}
            </span>
          </p>
          {request?.adminDecision === "reject" && (
            <>
              <div className="relative flex items-center gap-2">
                <p className="text-bg-black whitespace-nowrap text-xs font-semibold">
                  Admin Declined Reason:
                </p>
                <p className="max-w-[15rem] truncate text-xs font-normal text-red-500">
                  {request?.adminRejectedComments || "N/A"}
                </p>
                {canManage && (
                  <button
                    onClick={() =>
                      handleRejectedReasonEdit(
                        request?.adminRejectedComments,
                        request?.id,
                        setAdminRejectCommentUpdate(true),
                        setMatchUserRejectCommentUpdate(false),
                        setUserRejectCommentUpdate(false),
                      )
                    }
                    className="ml-2 text-blue-500 hover:text-blue-700"
                  >
                    <FaEdit />
                  </button>
                )}
              </div>
            </>
          )}
        </>
        {request?.user?.userdecision === "accepted" &&
          request?.matchUser?.matchedUserdecision === "accepted" && (
            <div className="text-left text-xs font-semibold">
              <p className="text-bg-black">
                {`${(request?.user?.name || "User").substring(0, 10)}${
                  (request?.user?.name || "").length > 10 ? "..." : ""
                }'s Approved Date:`}
                <span className="ml-1 font-normal">
                  {request?.user?.descisionAt
                    ? new Date(request.user.descisionAt).toLocaleDateString(
                        "en-GB",
                      )
                    : "N/A"}
                </span>
              </p>

              <p className="text-bg-black">
                {`${(request?.matchUser?.name || "Match User").substring(0, 10)}${
                  (request?.matchUser?.name || "").length > 10 ? "..." : ""
                }'s Approved Date:`}
                <span className="ml-1 font-normal">
                  {request?.matchUser?.descisionAt
                    ? new Date(
                        request.matchUser.descisionAt,
                      ).toLocaleDateString("en-GB")
                    : "N/A"}
                </span>
              </p>
            </div>
          )}

        {/* Show rejection details if either side rejected */}
        {(request?.user?.userdecision === "rejected" ||
          request?.matchUser?.matchedUserdecision === "rejected") && (
          <>
            {request?.user?.userdecision === "rejected" && (
              <>
                <p className="text-bg-black text-left text-xs font-semibold">
                  {`${(request?.user?.name || "User").substring(0, 6)}${
                    (request?.user?.name || "").length > 6 ? "..." : ""
                  }'s Declined Date:`}
                  <span className="font-normal">
                    {request?.user?.descisionAt
                      ? new Date(request?.user?.descisionAt).toLocaleDateString(
                          "en-GB",
                        )
                      : "N/A"}
                  </span>
                </p>
                <div className="relative flex items-center gap-2">
                  <p className="text-bg-black whitespace-nowrap text-xs font-semibold">
                    {`${(request?.user?.name || "User").substring(0, 6)}${
                      (request?.user?.name || "").length > 6 ? "..." : ""
                    }'s Declined Reason:`}
                  </p>
                  <p className="max-w-[15rem] truncate text-xs font-normal text-red-500">
                    {request?.user?.userComments || "N/A"}
                  </p>
                  {canManage && (
                    <button
                      onClick={() =>
                        handleRejectedReasonEdit(
                          request?.user?.userComments,
                          request?.id,
                          setUserRejectCommentUpdate(true),
                          setMatchUserRejectCommentUpdate(false),
                        )
                      }
                      className="ml-2 text-blue-500 hover:text-blue-700"
                    >
                      <FaEdit />
                    </button>
                  )}
                </div>
              </>
            )}
            {request?.matchUser?.matchedUserdecision === "rejected" && (
              <>
                <p className="text-bg-black text-left text-xs font-semibold">
                  {`${(
                    request?.matchUser?.name ||
                    request?.matchUser?.name ||
                    "Match User"
                  ).substring(0, 6)}${
                    (request?.matchUser?.name || request?.matchUser?.name || "")
                      .length > 6
                      ? "..."
                      : ""
                  }'s Declined Date:`}{" "}
                  <span className="font-normal">
                    {request?.matchUser?.descisionAt
                      ? new Date(
                          request.matchUser.descisionAt,
                        ).toLocaleDateString("en-GB")
                      : "N/A"}
                  </span>
                </p>
                <div className="relative flex items-center gap-2">
                  <p className="text-bg-black whitespace-nowrap text-xs font-semibold">
                    {`${(
                      request?.matchUser?.name ||
                      request?.matchUser?.name ||
                      "Match User"
                    ).substring(0, 6)}${
                      (
                        request?.matchUser?.name ||
                        request?.matchUser?.name ||
                        ""
                      ).length > 6
                        ? "..."
                        : ""
                    }'s Declined Reason:`}
                  </p>
                  <p className="max-w-[15rem] truncate text-xs font-normal text-red-500">
                    {request?.matchUser?.matchedUserComments || "N/A"}
                  </p>
                  {canManage && (
                    <button
                      onClick={() =>
                        handleRejectedReasonEdit(
                          request?.matchUser?.matchedUserComments,
                          request?.id,
                          setMatchUserRejectCommentUpdate(true),
                          setUserRejectCommentUpdate(false),
                        )
                      }
                      className="ml-2 text-blue-500 hover:text-blue-700"
                    >
                      <FaEdit />
                    </button>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>

      <p className="text-xs text-gray-400">Click profile to see full details</p>
      {isCommentSectionOpen && (
        <div className="popup-container fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-black bg-opacity-50">
          <RejectModel
            setComment={setComment}
            comment={comment}
            handleNoteChange={handleNoteChange}
            closeModal={closeModal}
            error={error}
            handleSaveComment={handleSaveComment}
            isShowDropdown={true}
          />
        </div>
      )}
      {/* Reject Revoke Confirmation Modal */}
      {showRejectRevokeConfirmation && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="w-[90%] rounded-lg bg-white p-4 shadow-lg sm:w-[60%] md:w-[40%]">
            <p className="mb-4 text-center text-sm sm:text-base">
              {Strings.REJECT_REVOKE_USER}
            </p>
            <div className="flex justify-around">
              <button
                onClick={() => handleAction(request?.id, "approve")}
                className="rounded bg-blue-500 px-4 py-2 text-white"
                disabled={revoking}
              >
                {revoking ? <Spinner size="small" /> : "Yes, Revoke"}
              </button>
              <button
                onClick={() => {
                  setRequestedId(null);
                  setShowRejectRevokeConfirmation(false);
                }}
                className="rounded bg-gray-300 px-4 py-2"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
const AdminSuggestion = () => {
  const adminId = getValueFromLocalStorage(localStorageKey.USERDATA, "adminId");
  const [userRequestData, setUserRequestData] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(true);
  const [userAcceptedRequest, setUserAcceptedRequest] = useState([]);
  const [adminRejectedRequest, setAdminRejectedRequest] = useState([]);
 const [searchQuery, setSearchQuery] = useState("");
  const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);  const [filter, setFilter] = useState("all");
  const [requests, setRequests] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [mutuallyAcceptedRequest, setMutuallyAcceptedRequest] = useState([]);
  const [userRejectedRequest, setUserRejectedRequest] = useState([]);
  useEffect(() => {
    const savedTab = parseInt(localStorage.getItem("activeTab")) || 0;
    const savedQuery = localStorage.getItem("searchQuery") || "";
    const savedSearchVisible =
      localStorage.getItem("showAdvanceSearch") === "true";

    setActiveTab(savedTab);
    setSearchQuery(savedQuery);
    setShowAdvanceSearch(savedSearchVisible);

    if (savedSearchVisible && savedQuery) {
      handleAdvanceSearch(savedQuery, requests, savedTab);
    } else {
      updateActiveTabData(requests, savedTab);
    }
  }, [requests]);
  useEffect(() => {
    getUserRequest();
  }, []);

  const getUserRequest = async () => {
    setLoading(true);
    try {
      const res = await authorizedGet(
        `${configuration.apis.getAllAdminSuggestions}?adminId=${adminId}`,
        config,
      );
      const response = res?.data?.data;
      if (res?.data?.status) {
        setRequests(response || []);
        setUserRequestData(response?.pending || []);
        setUserAcceptedRequest(response?.accepted || []);
        setUserRejectedRequest(response?.rejected || []);
        setMutuallyAcceptedRequest(response?.mutuallyAccepted || []);
        setAdminRejectedRequest(response?.adminRejected || []);
      } else {
        errorNotify(response?.message);
      }
    } catch (error) {
      errorNotify(Strings.ERROR);
      // console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTabClick = (index) => {
    setActiveTab(index);
    localStorage.setItem("activeTab", index);
  };

  const handleAdvanceSearch = (
    searchValue,
    data = requests,
    tab = activeTab,
  ) => {
    const query = searchValue.toLowerCase().trim();
    setSearchQuery(query);
    localStorage.setItem("searchQuery", query);

    setShowAdvanceSearch(true);
    localStorage.setItem("showAdvanceSearch", "true");

   const filterFunc = (list) =>
      list.filter((user) => {
        const userName = user?.user?.name?.toLowerCase() || "";
        const matchUserName = user?.matchUser?.name?.toLowerCase() || "";
        return userName.includes(query) || matchUserName.includes(query);
      });

    let filtered = [];

    if (tab === 0) {
      filtered = filterFunc(userRequestData);
      setUserRequestData(filtered);
    } else if (tab === 1) {
      filtered = filterFunc(userAcceptedRequest);
      setUserAcceptedRequest(filtered);
    } else if (tab === 2) {
      filtered = filterFunc(userRejectedRequest);
      setUserRejectedRequest(filtered);
    } else if (tab === 3) {
      filtered = filterFunc(mutuallyAcceptedRequest);
      setMutuallyAcceptedRequest(filtered);
    } else if (tab === 4) {
      filtered = filterFunc(adminRejectedRequest);
      setAdminRejectedRequest(filtered);
    }

    setSearchData(filtered);
  };

  const toggleSearchBar = () => {
    const newValue = !showAdvanceSearch;

    if (!newValue) {
      const savedTab = parseInt(localStorage.getItem("activeTab")) || 0;

      setSearchQuery("");
      localStorage.removeItem("searchQuery");

      setSearchData([]);
      setFilter("all");
      updateActiveTabData(requests, activeTab);
    }
    setShowAdvanceSearch(newValue);
    localStorage.setItem("showAdvanceSearch", newValue);
  };

  const updateActiveTabData = (data, tab) => {
    if (!data) return;

    if (tab === 0) {
      setUserRequestData(data?.pending || []);
    } else if (tab === 1) {
      setUserAcceptedRequest(data?.accepted || []);
    } else if (tab === 2) {
      setUserRejectedRequest(data?.rejected || []);
    } else if (tab === 3) {
      setMutuallyAcceptedRequest(data?.mutuallyAccepted || []);
    } else if (tab === 4) {
      setAdminRejectedRequest(data?.adminRejected || []);
    }

    setSearchData(
      tab === 0
        ? data?.pending || []
        : tab === 1
          ? data?.accepted || []
          : tab === 2
            ? data?.rejected || []
            : tab === 3
              ? data?.mutuallyAccepted || []
              : tab === 4
                ? data?.adminRejected || []
                : [],
    );
  };

  const filterRequests = (
    value,
    customStartDate = null,
    customEndDate = null,
  ) => {
    const today = new Date();
    const currentYear = today.getFullYear();
    setFilter(value);

    let data = { ...requests };
    const isSearchActive = searchQuery?.trim()?.length > 0;
    const query = searchQuery.toLowerCase().trim();

    const filterByName = (list) =>
      (list || []).filter((user) => {
        const userName = user?.user?.name?.toLowerCase() || "";
        const matchUserName = user?.matchUser?.name?.toLowerCase() || "";
        return userName.includes(query) || matchUserName.includes(query);
      });

    if (isSearchActive) {
      data = {
        pending: filterByName(data.pending),
        accepted: filterByName(data.accepted),
        rejected: filterByName(data.rejected),
        mutuallyAccepted: filterByName(data.mutuallyAccepted),
        adminRejected: filterByName(data.adminRejected),
      };
    }

    // Time-based filtering logic
    const isDateBasedFilter = [
      "today",
      "week",
      "month",
      "year",
      "q1",
      "q2",
      "q3",
      "q4",
      "h1",
      "h2",
      "custom",
    ].includes(value);

    if (isDateBasedFilter) {
      let startDate, endDate;

      switch (value) {
        case "today":
          startDate = new Date(today.setHours(0, 0, 0, 0));
          endDate = new Date();
          break;
        case "week":
          startDate = new Date();
          startDate.setDate(today.getDate() - 6);
          endDate = new Date();
          break;
        case "month":
          startDate = new Date(currentYear, today.getMonth(), 1);
          endDate = new Date();
          break;
        case "year":
          startDate = new Date(currentYear, 0, 1);
          endDate = new Date();
          break;
        case "q1":
          startDate = new Date(currentYear, 0, 1);
          endDate = new Date(currentYear, 2, 31);
          break;
        case "q2":
          startDate = new Date(currentYear, 3, 1);
          endDate = new Date(currentYear, 5, 30);
          break;
        case "q3":
          startDate = new Date(currentYear, 6, 1);
          endDate = new Date(currentYear, 8, 30);
          break;
        case "q4":
          startDate = new Date(currentYear, 9, 1);
          endDate = new Date(currentYear, 11, 31);
          break;
        case "h1":
          startDate = new Date(currentYear, 0, 1);
          endDate = new Date(currentYear, 5, 30);
          break;
        case "h2":
          startDate = new Date(currentYear, 6, 1);
          endDate = new Date(currentYear, 11, 31);
          break;
        case "custom":
          if (customStartDate && customEndDate) {
            startDate = new Date(customStartDate);
            endDate = new Date(customEndDate);
          } else {
            console.warn("Custom range requires start and end date.");
            return;
          }
          break;
      }

      const filterByDate = (list) =>
        (list || []).filter((user) => {
          const requestDate = new Date(user?.sentAt);
          return requestDate >= startDate && requestDate <= endDate;
        });

      data = {
        pending: filterByDate(data.pending),
        accepted: filterByDate(data.accepted),
        rejected: filterByDate(data.rejected),
        mutuallyAccepted: filterByDate(data.mutuallyAccepted),
        adminRejected: filterByDate(data.adminRejected),
      };
    }

    // Sort by latest
    const sortByDate = (list) =>
      [...(list || [])].sort((a, b) => new Date(b.sentAt) - new Date(a.sentAt));

    data = {
      pending: sortByDate(data.pending),
      accepted: sortByDate(data.accepted),
      rejected: sortByDate(data.rejected),
      mutuallyAccepted: sortByDate(data.mutuallyAccepted),
      adminRejected: sortByDate(data.adminRejected),
    };
    if (isSearchActive || isDateBasedFilter) {
      updateActiveTabData(data, activeTab);
    } else {
      setData(data);
    }
  };

  const setData = (data) => {
    if (!data) return;

    setUserRequestData(data?.pending || []);
    setUserAcceptedRequest(data?.accepted || []);
    setUserRejectedRequest(data?.rejected || []);
    setMutuallyAcceptedRequest(data?.mutuallyAccepted || []);
    setAdminRejectedRequest(data?.adminRejected || []);
  };

  const tabList = [
    { name: "Admin Suggestion", count: userRequestData.length },
    { name: "User Accepted", count: userAcceptedRequest.length },
    {
      name: "User Declined",
      count: userRejectedRequest.length,
    },
    {
      name: "Mutually Accepted",
      count: mutuallyAcceptedRequest.length,
    },
    { name: "Admin Declined", count: adminRejectedRequest.length },
  ];
  return (
    <div className="font-jost relative ml-4 h-auto rounded-lg p-2 ">
      <div className="flex w-full items-center justify-center text-xs text-gray-400 md:justify-end">
        Note: The details are sorted by the date the request was sent.
      </div>
      <div className="flex w-full flex-col justify-between border-b border-gray-300  md:flex-row">
        <ul className="flex flex-col justify-center md:flex-row">
          {tabList.map((list, index) => (
            <li
              key={index}
              className={`mt-3 cursor-pointer px-4 py-2 text-center text-textGreen transition-all ${showAdvanceSearch ? "text-[13px] xl:text-[16px]" : "sm:text-xs md:text-base"} 
                    ${
                      activeTab === index
                        ? "border-b-2 border-textYellow text-textYellow "
                        : "hover:bg-gray-100 hover:text-textYellow"
                    }`}
              onClick={() => handleTabClick(index)}
            >
              {list.name}({list.count})
            </li>
          ))}
        </ul>
        <div className="flex flex-wrap items-center justify-center">
          {/* Search and Sort  */}
          <div className="flex flex-row items-center gap-2 ">
            {/* Search Icon & Advanced Search */}
            <div className="flex items-center rounded-lg ">
              {!showAdvanceSearch ? (
                <IoIosSearch
                  className="cursor-pointer text-xl text-gray-500 sm:text-2xl"
                  onClick={toggleSearchBar}
                />
              ) : (
                <div className="flex items-center gap-2">
                  <AdvanceSearch
                    searchQuery={searchQuery}
                    onSearchValue={handleAdvanceSearch}
                  />
                  <ImCancelCircle
                    className="cursor-pointer text-lg text-gray-500 sm:text-xl"
                    onClick={toggleSearchBar}
                  />
                </div>
              )}
            </div>
            <div className="flex flex-col items-center">
              <p className="text-xs">sort by:</p>
              <select
                className="rounded-md border px-1 py-1 text-xs"
                value={filter}
                onChange={(e) => filterRequests(e.target.value)}
              >
                <option value="all">All</option>
                <option value="today">Today</option>
                <option value="week">This Week</option>
                <option value="month">This Month</option>
                <option value="year">This Year</option>

                <option value="q1">Q1 (Jan - Mar)</option>
                <option value="q2">Q2 (Apr - Jun)</option>
                <option value="q3">Q3 (Jul - Sep)</option>
                <option value="q4">Q4 (Oct - Dec)</option>

                <option value="h1">H1 (Jan - Jun)</option>
                <option value="h2">H2 (Jul - Dec)</option>

                {/* <option value="custom">Custom Range</option> */}

                {/* Conditional options */}
                {/* {activeTab === 3 && (
                  <>
                    <option value="userViewed">User Viewed</option>
                    <option value="requestedUserViewed">
                      Requested User Viewed
                    </option>
                    <option value="bothViewed">Both Viewed</option>
                    <option value="noneViewed">None Viewed</option>
                  </>
                )} */}
              </select>
            </div>
          </div>
        </div>
      </div>
      {activeTab === 0 && (
        <>
          {loading ? (
            <div className="flex min-h-screen flex-col items-center justify-center">
              <Spinner />
            </div>
          ) : userRequestData.length > 0 || searchData.length > 0 ? (
            <div className="flex flex-wrap gap-4 p-2">
              {userRequestData?.map((item, index) => (
                <SuggestionCards
                  key={index}
                  request={item}
                  activeTab={activeTab}
                  index={index}
                  adminId={adminId}
                  setUserRequestData={setUserRequestData}
                  setUserAcceptedRequest={setUserAcceptedRequest}
                  setAdminRejectedRequest={setAdminRejectedRequest}
                  setMutuallyAcceptedRequest={setMutuallyAcceptedRequest}
                  setUserRejectedRequest={setUserRejectedRequest}
                  setRequests={setRequests}
                />
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center p-2">
              <h4 className="text-black">No User Suggestion Available.</h4>
            </div>
          )}
        </>
      )}
      {activeTab === 1 && (
        <>
          {loading ? (
            <div className="flex min-h-screen flex-col items-center justify-center">
              <Spinner />
            </div>
          ) : userAcceptedRequest.length > 0 ? (
            <div className="flex flex-wrap gap-4 p-2">
              {userAcceptedRequest.map((item, index) => (
                <SuggestionCards
                  key={index}
                  request={item}
                  activeTab={activeTab}
                  index={index}
                  adminId={adminId}
                  setUserRequestData={setUserRequestData}
                  setUserAcceptedRequest={setUserAcceptedRequest}
                  setAdminRejectedRequest={setAdminRejectedRequest}
                  setMutuallyAcceptedRequest={setMutuallyAcceptedRequest}
                  setUserRejectedRequest={setUserRejectedRequest}
                  setRequests={setRequests}
                />
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center p-2">
              <h4 className="text-black">No Accepted Suggestion Available.</h4>
            </div>
          )}
        </>
      )}
      {activeTab === 2 && (
        <>
          {loading ? (
            <div className="flex min-h-screen flex-col items-center justify-center">
              <Spinner />
            </div>
          ) : userRejectedRequest.length > 0 ? (
            <div className="flex flex-wrap gap-4 p-2">
              {userRejectedRequest.map((item, index) => (
                <SuggestionCards
                  key={index}
                  request={item}
                  activeTab={activeTab}
                  index={index}
                  adminId={adminId}
                  setUserRequestData={setUserRequestData}
                  setUserAcceptedRequest={setUserAcceptedRequest}
                  setAdminRejectedRequest={setAdminRejectedRequest}
                  setMutuallyAcceptedRequest={setMutuallyAcceptedRequest}
                  setUserRejectedRequest={setUserRejectedRequest}
                  setRequests={setRequests}
                />
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center p-2">
              <h4 className="text-black">No Declined Suggestion Available.</h4>
            </div>
          )}
        </>
      )}
      {activeTab === 3 && (
        <>
          {loading ? (
            <div className="flex min-h-screen flex-col items-center justify-center">
              <Spinner />
            </div>
          ) : mutuallyAcceptedRequest.length > 0 ? (
            <div className="flex flex-wrap gap-4 p-2">
              {mutuallyAcceptedRequest.map((item, index) => (
                <SuggestionCards
                  key={index}
                  request={item}
                  activeTab={activeTab}
                  index={index}
                  adminId={adminId}
                  setUserRequestData={setUserRequestData}
                  setUserAcceptedRequest={setUserAcceptedRequest}
                  setAdminRejectedRequest={setAdminRejectedRequest}
                  setMutuallyAcceptedRequest={setMutuallyAcceptedRequest}
                  setUserRejectedRequest={setUserRejectedRequest}
                  setRequests={setRequests}
                />
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center p-2">
              <h4 className="text-black">
                No Mutually Accepted Suggestion Available.
              </h4>
            </div>
          )}
        </>
      )}
      {activeTab === 4 && (
        <>
          {loading ? (
            <div className="flex min-h-screen flex-col items-center justify-center">
              <Spinner />
            </div>
          ) : adminRejectedRequest?.length > 0 ? (
            <div className="flex flex-wrap gap-4 p-2">
              {adminRejectedRequest?.map((item, index) => (
                <SuggestionCards
                  key={index}
                  request={item}
                  activeTab={activeTab}
                  index={index}
                  adminId={adminId}
                  setUserRequestData={setUserRequestData}
                  setUserAcceptedRequest={setUserAcceptedRequest}
                  setAdminRejectedRequest={setAdminRejectedRequest}
                  setMutuallyAcceptedRequest={setMutuallyAcceptedRequest}
                  setUserRejectedRequest={setUserRejectedRequest}
                  setRequests={setRequests}
                />
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center p-2">
              <h4 className="text-black">
                No Admin Declined Suggestion Available.
              </h4>
            </div>
          )}
        </>
      )}
      <MessageBar />
    </div>
  );
};

export default AdminSuggestion;
